export default () => typeof window !== "undefined" && window.location.search.indexOf("f=np&auth0=1") > -1;
